import MessagePage from "components/pages/common/MessagePage";

export default function DisconnectedPage(): JSX.Element {
  return (
    <MessagePage>Please connect your wallet and create an account.</MessagePage>
  );
}
